module.exports = __webpack_public_path__ + "img/foto3.ad8db8f7.webp";